/**
 * The insurance category will be passed from the parameters
 */
const SERVER_URL = "/api/v2/products/:insuranceCategory";

export default {
  //insurance management
  getInsurerProductList: {
    method: "get",
    url: `/product/v1/internal/products/insurer/list`,
  },
  getInsurerProductDetail: {
    method: "get",
    url: `${SERVER_URL}/internal/products/insurer/detail/:id`,
  },
  addInsurerProduct: {
    method: "post",
    url: `${SERVER_URL}/products/insurer`,
  },
  updateInsurerProduct: {
    method: "patch",
    url: `${SERVER_URL}/internal/products/insurer/:id`,
  },
  deleteInsurerProduct: {
    method: "delete",
    url: `${SERVER_URL}/internal/products/insurer/:id`,
  },

  //insurance category management
  getInsuranceCategories: {
    method: "get",
    url: "/product-service/v1/internal/insurance-categories",
  },
  createInsuranceCategories: {
    method: "post",
    url: "/product-service/v1/internal/insurance-categories",
  },
  gerInsuranceCategoriesDetail: {
    method: "get",
    url: "/product-service/v1/internal/insurance-categories/:id",
  },
  updateInsuranceCategories: {
    method: "put",
    url: "/product-service/v1/internal/insurance-categories/:id",
  },
  deleteInsuranceCategories: {
    method: "delete",
    url: "/product-service/v1/internal/insurance-categories/:id",
  },
  getInsuranceCategoryAssociations: {
    method: "get",
    url: "/product-service/v2/internal/insurance-categories/:code/associations",
  },
  createInsuranceCategoryAssociation: {
    method: "post",
    url: "/product-service/v2/internal/insurance-categories/:code/associations",
  },
  createPresignInsuranceCategoryAssociation: {
    method: "post",
    url: "/product-service/v2/internal/insurance-categories/presigned-create",
  },
  getInsuranceCategoryAssociationDetail: {
    method: "get",
    url: "/product-service/v2/internal/insurance-categories/:code/associations/:id",
  },
  updateInsuranceCategoryAssociation: {
    method: "put",
    url: "/product-service/v2/internal/insurance-categories/:code/associations/:id",
  },
  deleteInsuranceCategoryAssociation: {
    method: "delete",
    url: "/product-service/v2/internal/insurance-categories/:code/associations/:id",
  },
};
